import { useAppContext, useConfigContext } from '@fe-core';
import { CatalogPage } from '@routes/catalog/CatalogPage';
import { CatalogSkeleton } from '@routes/catalog/CatalogSkeleton';
import { useSessionsData } from './hooks/useSessionsData';
import { useFilters } from '@hooks/data/useFilters';
import { useError } from '@hooks/useError';
import { Loader } from '@fe-learner-common/components/Loader';
import { setupLuxon } from '@fe-learner-common/utils/date';

export const CatalogRouteLoader = () => {
  const { config } = useConfigContext();
  const { isLoading: isLoadingAppContext } = useAppContext();
  setupLuxon(config.locale || 'en');
  const emitError = useError();

  const { isLoading: isLoadingSessions, error } = useSessionsData();

  const { isLoading: isLoadingFilter } = useFilters({
    enabled: true,
  });

  if (error) {
    emitError({
      error: error,
      errorMapOverride: {
        type: 'modal',
      },
    });
  }

  const isLoading =
    isLoadingAppContext || isLoadingSessions || isLoadingFilter || !!error;

  return (
    <Loader isLoading={isLoading} skeleton={<CatalogSkeleton />}>
      <CatalogPage />
    </Loader>
  );
};
